export const ATTRIBUTE_DRAG='#aec1ee'
export const ATTRIBUTE_DROP='#46ca70'
export const ATTRIBUTE_HOVER='#46ca70'
export const ATTIBUTE_DEFAULT='#f3f3f7'